import {
    DASHBOARD_YEAR_FILTER,
    DASHBOARD_QUARTER_FILTER,
    DASHBOARD_MONTH_FILTER,
    DASHBOARD_SEARCH_TRIGGER
} from '../constants/ActionTypes';

export const dashboardSelectYear = payload => {
    return {
        type: DASHBOARD_YEAR_FILTER,
        payload
    }
}

export const dashboardSelectQuarter = payload => {
    return {
        type: DASHBOARD_QUARTER_FILTER,
        payload
    }
}

export const dashboardSelectMonth = payload => {
    return {
        type: DASHBOARD_MONTH_FILTER,
        payload
    }
}

export const dashboardSearchTrigger = payload => {
    return {
        type: DASHBOARD_SEARCH_TRIGGER,
        payload
    }
}